import React, {useEffect} from "react";
import Breadcrumb from "../Components/Breadcrumb";
import Faqs from "../Components/Faqs";
import Cta from "../Components/Cta";
import ContactSection from "../Components/ContactSection";
import SchemaMarkup from "../Components/SchemaMarkup";
import ContactPageSchema from "../Schema/ContactPageSchema";
import BreadcrumbSchema from "../Schema/BreadcrumbSchema";

const Contact=()=>{

useEffect(() => {
    document.title =
      "Contact ONBBITS | Get in Touch with Our Team";

    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) {
      metaDesc.setAttribute(
        "content",
        "Have questions? Reach out to ONBBITS for support, chat with our sales team on WhatsApp, or send us a message. We are here to help your business grow."
      );
    }

     const canonical = document.querySelector("link[rel='canonical']");
  if (canonical) {
    canonical.setAttribute("href", "https://onbbits.io/contact-us");
  }

  const ogTitle = document.querySelector("meta[property='og:title']");
  if (ogTitle) {
    ogTitle.setAttribute(
      "content",
      "Contact ONBBITS | Get in Touch with Our Team"
    );
  }

    const ogDesc = document.querySelector("meta[property='og:description']");
  if (ogDesc) {
    ogDesc.setAttribute(
      "content",
      "Have questions? Reach out to ONBBITS for support, chat with our sales team on WhatsApp, or send us a message. We are here to help your business grow."
    );
  }

  const ogUrl = document.querySelector("meta[property='og:url']");
  if (ogUrl) {
    ogUrl.setAttribute("content", "https://onbbits.io/contact-us");
  }

    const ogImage = document.querySelector("meta[property='og:image']");
  if (ogImage) {
    ogImage.setAttribute(
      "content",
      "https://onbbits.io/Images/api-integration.webp"
    );
  }

    const twitterTitle = document.querySelector("meta[name='twitter:title']");
  if (twitterTitle) {
    twitterTitle.setAttribute(
      "content",
      "Contact ONBBITS | Get in Touch with Our Team"
    );
  }

    const twitterDesc = document.querySelector(
    "meta[name='twitter:description']"
  );
  if (twitterDesc) {
    twitterDesc.setAttribute(
      "content",
      "Have questions? Reach out to ONBBITS for support, chat with our sales team on WhatsApp, or send us a message. We are here to help your business grow."
    );
  }

    const twitterImage = document.querySelector("meta[name='twitter:image']");
  if (twitterImage) {
    twitterImage.setAttribute(
      "content",
      "https://onbbits.io/Images/api-integration.webp"
    );
  }
  }, [])

    return(
        <>

      <SchemaMarkup
  data={ContactPageSchema({
    name: "Contact ONBBITS",
    description:
      "Get in touch with ONBBITS for WhatsApp Business API, automation, customer engagement, messaging solutions, and business communication support.",
    url: "https://onbbits.io/contact"
  })}
/>

<SchemaMarkup
  data={BreadcrumbSchema({
    items: [
      {
        name: "Home",
        url: "https://onbbits.io/"
      },
      {
        name: "Contact",
        url: "https://onbbits.io/contact"
      }
    ]
  })}
/>


         {/**BREADCRUMB */}
        <Breadcrumb title="Let's talk." />

        {/**CONTACT FORM SECTION */}
        <ContactSection />

        {/**FAQS SECTION */}
        <Faqs />

        {/**CTA SECTION */}
        <Cta />

        </>
    )
}
export default Contact;